import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerModelliVersamentoModalComponent } from './worker-modelli-versamento-modal';

export const WorkerModelliVersamentoModalModule: string = ng
    .module('worker-modelli-versamento-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerModelliVersamentoModalComponent', WorkerModelliVersamentoModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-modelli-versamento-modal/worker-modelli-versamento-modal.module.ts